import React, { useEffect, useState } from "react";

const App = React.createContext();

function AppProvider({ children }) {
  const [modal, setModal] = useState(false);
  const [stickyModal, setStickyModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [rentDropdown, setRentDropdown] = useState(false);
  const [buynowDropdown, setBuynowDropdown] = useState(false);

  function handleModal() {
    setModal(!modal);
    setStickyModal(!stickyModal);
  }

  function handleRentDropdown() {
    if (buynowDropdown) {
      setBuynowDropdown(false);
    }
    setRentDropdown(!rentDropdown);
  }

  function handleBuynowDropdown() {
    if (rentDropdown) {
      setRentDropdown(false);
    }
    setBuynowDropdown(!buynowDropdown);
  }

  function handleStickyModal() {
    setStickyModal(!stickyModal);
    setModal(!modal);
  }

  useEffect(() => {
    setCurrentSlide(currentSlide);
  }, [currentSlide]);

  return (
    <App.Provider
      value={{
        modal,
        handleModal,
        stickyModal,
        handleStickyModal,
        currentSlide,
        setCurrentSlide,
        rentDropdown,
        setRentDropdown,
        handleRentDropdown,
        buynowDropdown,
        setBuynowDropdown,
        handleBuynowDropdown,
      }}
    >
      {children}
    </App.Provider>
  );
}

export { App, AppProvider };
